export default "__VITE_ASSET__Bk506c0f__"